import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["country", "city", "county", "state"];

  connect() {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => this.success(position),
      (error) => this.error(error)
    );
  }

  success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    this.fetchAddress(latitude, longitude);
  }

  error(error) {
    console.error("Error getting location:", error.message);
    alert("Unable to retrieve your location.");
  }

  async fetchAddress(latitude, longitude) {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    const data = await response.json();
    this.countryTarget.value = data.address.country || "";
    this.cityTarget.value = data.address.city || "";
    this.countyTarget.value = data.address.county || "";
    this.stateTarget.value = data.address.state || "";
  }
}
